
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
    ExportButton: () => import("@/components/ExportButton.vue")
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      if (!val) return "";
      return String(val).formatMoney();
    },
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    }
  }
})
export default class Claims extends Vue {
  exportApiUrl: string = "claims/exportxls";
  adminRoles: any = [];
  dictionary: any = {};
  title: string = "";
  filter: any = {
    businessId: "",
    companyId: "",
    controlZoneId: "",
    month: "",
    year: "",
    reporttype: "",
    branchId: "",
    trimester: "",
    status_client: "",
    status_admin: "",
    code: "",
    requestNumber: "",
    policy_number: "",
    seguredName: "",
    claimCode: "",
    claimNumber: "",
    batchStateId: "",
    modifyType: -1
  };
  currentClaim: number = 0;
  claims: any = [];
  claimsIds: any = [];
  selectedClaims: any = [];
  businesses: any = [];
  companies: any = [];
  controlzones: any = [];
  branches: any = [];
  batchesStates: any = [];
  months: any = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Augosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  statuses: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  checkbox: any = {
    visible: false,
    allSelected: true
  };
  sortColumns: Record<string, string> = {
    name: "Contrato",
    owner: "Responsable",
    deletedAt: "Estado"
  };
  currentSort: Record<string, string> = {
    col: "claims.order",
    dir: "asc"
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadBusinesses();
    await this.loadCompanies();
    await this.loadBranches();
    await this.init();
  }

  async init() {
    this.filter.modifyType = -1;
    this.title = "Listado de Siniestros";
    this.loadControlZones();
    this.loadTrimesters();
    this.loadStatuses();
    this.loadBatchesStates();
    this.loadClaims(1, this.currentSort);
  }

  showDeleteModal(id: number) {
    this.currentClaim = id;
    (this.$refs.modal as any).show();
  }

  async deleteRequest() {
    try {
      let response: any = await (this.$root as any)._delete(
        `claims/${this.currentClaim}`
      );
      this.loadClaims(1, this.currentSort);
      (this.$refs.modal as any).hide();
      (this.$root as any).notify("Se elimino el siniestro con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar el siniestro.", "error");
    }
  }
  /*
  async exportRequests() {
    try {
      const response: any = await (this.$root as any)._post(
        "claims/exportxls",
        {
          ...this.filter
        }
      );
      let result = await (this.$root as any)._getFile(response.path);
      let fileName = response.path.split('/').slice(-1);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
     
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }
  */
  clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      if (key === "modifyType") this.filter[key] = -1;
      else this.filter[key] = "";
    });
    this.loadClaims(1, this.currentSort);
  }

  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    if (status === 8) return "pendingForEndorsement";
    return "inactive";
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadClaims(page, this.currentSort, true);
  }

  async loadClaims(page: number, sort: Record<string, string>, pageChange: Boolean = false) {
    this.currentSort = sort;

    const response: any = await (this.$root as any)._post("claims/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      ...this.filter
    });

    this.prepareClaims(response.data, pageChange)

    this.totalRows = response.totalRows;
  }

  async prepareClaims(data: any[], isPageChange: Boolean) {

    let isBatchUnassigned = this.filter.batchStateId === "-1";
    let isCompanyFiltered = this.filter.companyId !== "";

    if (isBatchUnassigned && !isCompanyFiltered) {
      (this.$root as any).notify(
        "Recuerde que para generar un nuevo batch debe filtrar por contrato.",
        "warn"
      );
    }

    let isGenerateBatch = isCompanyFiltered && isBatchUnassigned;

    if (isGenerateBatch) {
      if (!isPageChange) {
        const claimsIds: any = await (this.$root as any)._post("claims/ids", {
          order: this.currentSort,
          ...this.filter
        });

        this.checkbox = {
          visible: true,
          allSelected: true
        };

        this.claimsIds = claimsIds.data;
        this.selectedClaims = claimsIds.data;
      }

      this.claims = data.map((claim: any) => ({
        ...claim,
        selected: this.selectedClaims.includes(claim.id)
      }));
    } else {
      this.checkbox = {
        visible: false,
        allSelected: true
      };

      this.claims = data;
    }
  }

  validateBatchCreation() {
    if (this.selectedClaims.length !== 0) {
      (this.$refs.alertBatch as any).show();
    } else {
      (this.$root as any).notify("No ha seleccionado ningún siniestro para generar un batch. Seleccione al menos uno para continuar.", "error");
    }
  }

  async generateBatch() {
    try {
      (this.$refs.alertBatch as any).hide();
      (this.$refs.processingBatch as any).show();

      await (this.$root as any)._post(`batches/claims`, {
        claimsIds: this.selectedClaims
      });

      (this.$refs.processingBatch as any).hide();
      (this.$refs.successBatch as any).show();
      this.loadClaims(1, this.currentSort);
    } catch (e) {
      (this.$refs.processingBatch as any).hide();
      (this.$root as any).notify(e.message, "error");
    }
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadBusinesses() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.businesses = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all", {
      businessId: this.filter.businessId,
      businessFilter: this.filter.businessId != ""
    });

    this.companies = response.data;
  }

  async loadControlZones() {
    const response: any = await (this.$root as any)._post("controlzones/all");
    this.controlzones = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get("requests/trimesters");
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadBatchesStates() {
    const response: any = await (this.$root as any)._get(`batches/states`);
    this.batchesStates = response.data
  }

  //SelectAll functions

  toggleSelectAll() {
    let allSelected = this.checkbox.allSelected

    this.selectedClaims = allSelected ? [] : this.claimsIds

    this.checkbox.allSelected = !allSelected

    this.claims = this.claims.map((claim: any) => ({
      ...claim,
      selected: !allSelected
    }));
  }

  toggleSelect(request: any) {
    let isSelected = this.selectedClaims.includes(request.id);

    if(isSelected) {
      this.selectedClaims = this.selectedClaims.filter((id: number) => id !== request.id)
    } else {
      this.selectedClaims.push(request.id)
    }

    request.selected = !isSelected
    this.isAllSelected();
  }

  isAllSelected() {
    this.checkbox.allSelected = this.claimsIds.length === this.selectedClaims.length
  }
}
